import React from 'react';
import '../ItServices/CyberSecurity.css';
import { useNavigate } from 'react-router-dom';

const CyberSecurity = () => {
  const navigate = useNavigate();

  const goToContact = () => {
    navigate('/contactus');
  };

  return (
    <div className="cyber-page">

      {/* Hero Section */}
      <section className="cyber-hero">
        <div className="hero-overlay">
          <h1>Protect Your Business with Expert Cybersecurity Solutions</h1>
          <p>
            Safeguard your digital future with enterprise-grade protection against cyber threats,
            data breaches, and attacks.
          </p>
          <button onClick={goToContact}>Get Started</button>
        </div>
      </section>

      {/* Services */}
      <section className="cyber-services">
        <h2>Our Cybersecurity Services</h2>
        <div className="cyber-cards">
          <div className="cyber-card">
            <h3>Threat Detection</h3>
            <p>Identify real-time anomalies and potential threats using AI-powered systems.</p>
          </div>
          <div className="cyber-card">
            <h3>Penetration Testing</h3>
            <p>Simulated attacks to find and eliminate weaknesses in your system.</p>
          </div>
          <div className="cyber-card">
            <h3>Network Security</h3>
            <p>Prevent unauthorized access and ensure safe data transmission across networks.</p>
          </div>
          <div className="cyber-card">
            <h3>Email Protection</h3>
            <p>Shield your business communications from phishing and malware attacks.</p>
          </div>
          <div className="cyber-card">
            <h3>Firewall & Endpoint Security</h3>
            <p>Secure devices and perimeters against intrusions and zero-day attacks.</p>
          </div>
          <div className="cyber-card">
            <h3>Security Audits</h3>
            <p>Comprehensive security checks and policy enforcement reviews.</p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="cyber-process">
        <h2>How We Work</h2>
        <div className="process-steps">
          <div className="step">
            <h4>1. Assessment</h4>
            <p>We start with a detailed risk and threat assessment for your environment.</p>
          </div>
          <div className="step">
            <h4>2. Strategy</h4>
            <p>We craft a customized cybersecurity plan based on your goals and risks.</p>
          </div>
          <div className="step">
            <h4>3. Implementation</h4>
            <p>Our team deploys robust security systems, firewalls, and policies.</p>
          </div>
          <div className="step">
            <h4>4. Monitoring & Support</h4>
            <p>We offer 24/7 monitoring and real-time threat mitigation support.</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="cyber-why">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>ISO-Certified Cybersecurity Professionals</li>
          <li>AI-Driven Security Monitoring</li>
          <li>Tailored, Scalable Solutions</li>
          <li>Affordable Pricing Packages</li>
          <li>24/7 Dedicated Support Team</li>
        </ul>
      </section>

  {/* Testimonials Section */}
<section className="cyber-testimonials">
  <h2>What Our Clients Say</h2>
  <div className="testimonial-list">
    <div className="testimonial">
      <p>“The cybersecurity solutions provided were top-notch. We feel secure now.”</p>
      <h4>– A. Sharma, IT Head</h4>
    </div>
    <div className="testimonial">
      <p>“Their 24/7 monitoring helped us prevent a major data breach.”</p>
      <h4>– M. Verma, CEO</h4>
    </div>
    <div className="testimonial">
      <p>“Professional, quick, and reliable team. Highly recommended.”</p>
      <h4>– R. Desai, CTO</h4>
    </div>
  </div>
</section>

{/* FAQ Section */}
<section className="cyber-faq">
  <h2>Frequently Asked Questions</h2>
  <div className="faq-item">
    <div className="faq-question">What industries do you serve?</div>
    <div className="faq-answer">We serve finance, healthcare, education, IT, and more.</div>
  </div>
  <div className="faq-item">
    <div className="faq-question">Do you offer 24/7 monitoring?</div>
    <div className="faq-answer">Yes, our SOC operates 24/7 for real-time threat detection and response.</div>
  </div>
  <div className="faq-item">
    <div className="faq-question">Is penetration testing part of your service?</div>
    <div className="faq-answer">Yes, we offer regular penetration tests to ensure system resilience.</div>
  </div>
</section>


      {/* Final Call to Action */}
      <section className="cyber-contact">
        <h2>Secure Your Business Today</h2>
        <p>Let’s schedule a free consultation and take your cybersecurity to the next level.</p>
        <button onClick={goToContact}>Contact Us</button>
      </section>

    </div>
  );
};

export default CyberSecurity;
